<template>
  <div id="timeZone">
    <form @submit="handelSubmit" class="timeZoneForm">
      <h2>أختر منطقتك الزمنية</h2>


      <input :style="{ display: popup }" type="text" list="browseBc" v-model="contintent" placeholder="أسم القارة">
      <datalist id="browseBc">
        <option v-for="item in bigCountry" :key="item"> {{ item }}</option>
      </datalist>


      <!-- country -->
      <input type="text" list="browseCountry" required placeholder="أسم البلد" v-model="country">
      <datalist id="browseCountry">
        <option v-for="item in all" :key="item.en[0]">{{ item.en[0] }}</option>
      </datalist>

      <center>
        <input type="checkbox" id="cbx">&nbsp;&nbsp;
        <label for="cbx"> حفظ إسم البلد </label>
      </center>


      <!-- city -->
      <!-- <input type="text" list="browseCity" required v-model="capital" placeholder="أسم المدينة">
            <datalist id="browseCity">
                <option v-for="item in all" :key="item.en[1]"> {{ item.en[1] }}</option>
            </datalist> -->

      <!-- <label for="saveTimeZoneCbx">
                <span>
                حفظ المنطقة الزمنية المختارة
                </span>
                &nbsp;&nbsp;
                <input type="checkbox" v-model="checkSave" name="timeZoneCbx" id="saveTimeZoneCbx">
            </label> -->

      <button type="submit">حفظ</button>

      <!-- <small>
                سيتم تحديد العاصمة في حال عدم إيجاد زمن المدينة المختارة
            </small> -->
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // checkSave: false,
      popup: "none",
      country: "",
      capital: "",
      contintent: "",
      bigCountry: ["Europe", "Asia", "Africa", "Americas"],
      all: [
        {
          ar: ["أفغانستان", "كابول"],
          en: ["Afghanistan", "Kabul"]
        },
        {
          ar: ["الجزائر", "الجزائر"],
          en: ["Algeria", "Algiers"]
        },
        {
          ar: ["أندونيسيا", "جاكرتا"],
          en: ["Indonesia", "Jakarta"]
        },
        {
          ar: ["البحرين", "المنامة"],
          en: ["Bahrain", "Manama"]
        },
        {
          ar: ["بنغلاديش", "دكا"],
          en: ["Bangladesh", "Dhaka"]
        },
        {
          ar: ["بروناي", "بندر سري بيغاوان"],
          en: ["Brunei", "Bandar Seri Begawan"]
        },
        {
          ar: ["بوركينا فاسو", "واغادوغو"],
          en: ["Burkina Faso", "Ouagadougou"]
        },
        {
          ar: ["تشاد", "نجامينا"],
          en: ["Chad", "N'Djamena"]
        },
        {
          ar: ["جيبوتي", "جيبوتي"],
          en: ["Djibouti", "Djibouti"]
        },
        {
          ar: ["مصر", "القاهرة"],
          en: ["Egypt", "Cairo"]
        },
        {
          ar: ["إريتريا", "أسمرة"],
          en: ["Eritrea", "Asmara"]
        },
        {
          ar: ["إثيوبيا", "أديس أبابا"],
          en: ["Ethiopia", "Addis Ababa"]
        },
        {
          ar: ["غابون", "ليبرفيل"],
          en: ["Gabon", "Libreville"]
        },
        {
          ar: ["غامبيا", "بانجول"],
          en: ["Gambia", "Banjul"]
        },
        {
          ar: ["غانا", "أكرا"],
          en: ["Ghana", "Accra"]
        },
        {
          ar: ["غينيا", "كوناكري"],
          en: ["Guinea", "Conakry"]
        },
        {
          ar: ["إيران", "طهران"],
          en: ["Iran", "Tehran"]
        },
        {
          ar: ["العراق", "بغداد"],
          en: ["Iraq", "Baghdad"]
        },
        {
          ar: ["الأردن", "عمان"],
          en: ["Jordan", "Amman"]
        },
        {
          ar: ["الكويت", "الكويت"],
          en: ["Kuwait", "Kuwait City"]
        },
        {
          ar: ["لبنان", "بيروت"],
          en: ["Lebanon", "Beirut"]
        },
        {
          ar: ["ليبيا", "طرابلس"],
          en: ["Libya", "Tripoli"]
        },
        {
          ar: ["ماليزيا", "كوالالمبور"],
          en: ["Malaysia", "Kuala Lumpur"]
        },
        {
          ar: ["جزر المالديف", "ماليه"],
          en: ["Maldives", "Male"]
        },
        {
          ar: ["مالي", "باماكو"],
          en: ["Mali", "Bamako"]
        },
        {
          ar: ["موريتانيا", "نواكشوط"],
          en: ["Mauritania", "Nouakchott"]
        },
        {
          ar: ["المغرب", "الرباط"],
          en: ["Morocco", "Rabat"]
        },
        {
          ar: ["موريشيوس", "بورت لويس"],
          en: ["Mauritius", "Port Louis"]
        },
        {
          ar: ["نيجريا", "أبوجا"],
          en: ["Nigeria", "Abuja"]
        },
        {
          ar: ["عُمان", "مسقط"],
          en: ["Oman", "Muscat"]
        },
        {
          ar: ["باكستان", "إسلام آباد"],
          en: ["Pakistan", "Islamabad"]
        },
        {
          ar: ["فلسطين", "القدس"],
          en: ["Palestine", "Jerusalem"]
        },
        {
          ar: ["قطر", "الدوحة"],
          en: ["Qatar", "Doha"]
        },
        {
          ar: ["المملكة العربية السعودية", "الرياض"],
          en: ["Saudi Arabia", "Riyadh"]
        },
        {
          ar: ["السنغال", "داكار"],
          en: ["Senegal", "Dakar"]
        },
        {
          ar: ["الصومال", "مقديشيو"],
          en: ["Somalia", "Mogadishu"]
        },
        {
          ar: ["السودان", "الخرطوم"],
          en: ["Sudan", "Khartoum"]
        },
        {
          ar: ["سوريا", "دمشق"],
          en: ["Syria", "Damascus"]
        },
        {
          ar: ["تونس", "تونس"],
          en: ["Tunisia", "Tunis"]
        },
        {
          ar: ["تركيا", "أنقرة"],
          en: ["Turkey", "Ankara"]
        },
        {
          ar: ["الإمارات العربية المتحدة", "أبوظبي"],
          en: ["United Arab Emirates", "Abu Dhabi"]
        },
        {
          ar: ["اليمن", "صنعاء"],
          en: ["Yemen", "Sana'a"]
        },

        {
          ar: ["توجو", "لومي"],
          en: ["Togo", "Lomé"]
        },
        {
          ar: ["أوغندا", "كامبالا"],
          en: ["Uganda", "Kampala"]
        },
        {
          ar: ["أوزبكستان", "طشقند"],
          en: ["Uzbekistan", "Tashkent"]
        },
        {
          ar: ["فيتنام", "هانوي"],
          en: ["Vietnam", "Hanoi"]
        }
      ],

    }
  },
  methods: {
    // bigCountry filter
    afunction() {
      if (this.country == "Chad" ||
        this.country == "Djibouti" ||
        this.country == "Senegal" ||
        this.country == "Nigeria" ||
        this.country == "Morocco" ||
        this.country == "Somalia" ||
        this.country == "Libya" ||
        this.country == "Guinea" ||
        this.country == "Ghana" ||
        this.country == "Gambia" ||
        this.country == "Gabon" ||
        this.country == "Ethiopia" ||
        this.country == "Eritrea" ||
        this.country == "Egypt" ||
        this.country == "Tunisia" ||
        this.country == "Algeria" ||
        this.country == "Sudan") {
        this.contintent = "Africa";
      }
      else if (this.country == "Afghanistan" ||
        this.country == "Indonesia" ||
        this.country == "Bahrain" ||
        this.country == "Bangladesh" ||
        this.country == "Iran" ||
        this.country == "Kuwait" ||
        this.country == "Iraq" ||
        this.country == "Jordan" ||
        this.country == "Lebanon" ||
        this.country == "Malaysia" ||
        this.country == "Oman" ||
        this.country == "Pakistan" ||
        this.country == "Palestine" ||
        this.country == "Qatar" ||
        this.country == "Saudi Arabia" ||
        this.country == "Syria" ||
        this.country == "Turkey" ||
        this.country == "Yemen" ||
        this.country == "Uzbekistan" ||
        this.country == "Vietnam" ||
        this.country == "United Arab Emirates") {
        this.contintent = "Asia";
      }
      else { this.contintent = "Europe"; }
    },
    handelSubmit(event) {
      event.preventDefault();
      this.afunction();

      // handel city name
      for(var x = 0 ; x < this.all.length ; x++) { 
        if(this.country == this.all[x].en[0]) {
          this.capital = this.all[x].en[1];
          break;
        }
      }

      console.log(` data before emit is: 
        ${this.contintent.charAt(0).toUpperCase()}${this.contintent.slice(1,).replace(/\s+/g, "").trim()}:${this.country.charAt(0).toUpperCase()}${this.country.slice(1,).replace(/\s+/g, "").trim()}:${this.capital.charAt(0).toUpperCase()}${this.capital.slice(1,).replace(/\s+/g, "").trim()}`);
      
        this.$emit("emitTimeZone",
        this.contintent.charAt(0).toUpperCase() + this.contintent.slice(1,).replace(/\s+/g, "").trim() + ":" +
        this.country.charAt(0).toUpperCase() + this.country.slice(1,).replace(/\s+/g, "").trim() + ":" +
        this.capital.charAt(0).toUpperCase() + this.capital.slice(1,).replace(/\s+/g, "").trim()
        // this.checkSave
      );
      if(window.cbx.checked == !true) {
        window.localStorage.removeItem("timeZone");
      } 
      // this.$router.push = "/home";
    }
    
  }
}
</script>

<style scoped>
#timeZone {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #0007;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dedede;
  z-index: 1000;
}

.timeZoneForm {
  gap: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

input[type="text"] {
  all: unset;
  border: 2px solid var(--mainColor);
  border-radius: 4px;
  padding: 5px 12.5px;
  background: #0003;
  width: 200px;
  margin: 10px;
  transition: 0.3s ease box-shadow;
}

button {
  text-align: center;
  padding: 5px;
  width: 200px;
  color: #dedede;
  background: var(--mainColor);
  margin: 10px;
  border-radius: 4px;
}

button:hover,
input[type="text"]:focus {
  box-shadow: 0 0 0 5px var(--mainColorOpacity);
}
</style>
